// Consulta de CEP via ViaCEP — API pública gratuita, sem necessidade de chave.
export async function buscarEnderecoPorCep(cep) {
  const limpo = (cep || '').replace(/\D/g, '');
  if (limpo.length !== 8) throw new Error('Informe um CEP válido (8 dígitos)');
  const resp = await fetch(`https://viacep.com.br/ws/${limpo}/json/`);
  if (!resp.ok) throw new Error('Erro ao consultar o CEP');
  const data = await resp.json();
  if (data.erro) throw new Error('CEP não encontrado');
  return data; // { cep, logradouro, complemento, bairro, localidade, uf, ... }
}

export function formatarCep(valor) {
  return (valor || '').replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
}

// Valores iniciais dos campos de endereço estruturado — usar como spread no
// FORM_VAZIO de cada tela que usa <EnderecoFields />.
export const ENDERECO_VAZIO = { cep: '', endereco: '', numero: '', bairro: '', cidade: '', estado: '' };

// Monta uma linha de exibição a partir dos campos estruturados (telas de detalhe/PDF).
export function formatarEnderecoCompleto({ endereco, numero, bairro, cidade, estado }) {
  const linha1 = [endereco, numero].filter(Boolean).join(', ');
  const linha2 = [bairro, [cidade, estado].filter(Boolean).join(' - ')].filter(Boolean).join(', ');
  return [linha1, linha2].filter(Boolean).join(' — ');
}
